import _ from 'lodash'

export const INIT_FLOW_PAGE = 'INIT_FLOW_PAGE'

export const UPDATE_FLOW_PROPERTIES = 'UPDATE_FLOW_PROPERTIES'
export const SAVE_FLOW = 'SAVE_FLOW'
export const SAVE_FLOW_SUCCESS = 'SAVE_FLOW_SUCCESS'
export const SAVE_AND_PUBLISH_FLOW = 'SAVE_AND_PUBLISH_FLOW'
export const SAVE_AND_PUBLISH_FLOW_SUCCESS = 'SAVE_AND_PUBLISH_FLOW_SUCCESS'

export const DELETE_FLOW = 'FLOW/DELETE_FLOW'

export const ADD_ACTION = 'ADD_ACTION'
export const UPDATE_ACTION = 'UPDATE_ACTION'
export const DELETE_ACTION = 'DELETE_ACTION'
export const UPDATE_ACTIONS_ORDER = 'UPDATE_ACTIONS_ORDER'
export const UPDATE_CHOICES_ORDER = 'UPDATE_CHOICES_ORDER'
export const SHOW_UNSAVE_MESSAGE = 'SHOW_UNSAVE_MESSAGE'
export const HIDE_UNSAVE_MESSAGE = 'HIDE_UNSAVE_MESSAGE'

export const SET_FLOW_HISTORY = 'SET_FLOW_HISTORY'
export const UPDATE_FLOW_HISTORY = 'UPDATE_FLOW_HISTORY'

export const CREATE_STEP = 'CREATE_STEP'
export const DELETE_STEP = 'DELETE_STEP'
export const UPDATE_STEP_NAME = 'UPDATE_STEP_NAME'

export const SET_ACTIVE_FLOW = 'SET_ACTIVE_FLOW'
export const UNSET_ACTIVE_FLOW = 'UNSET_ACTIVE_FLOW'
export const FETCH_FLOW = 'FETCH_FLOW'
export const UPDATE_BOT_RESPONSE_SETTINGS = 'UPDATE_BOT_RESPONSE_SETTINGS'
export const FETCH_FLOW_DONE = 'FETCH_FLOW_DONE'

export const initFlowPage = (payload) => {
  const { botId, flowId } = payload
  return {
    type: INIT_FLOW_PAGE,
    payload: {
      botId,
      flowId
    }
  }
}

export const updateFlowProperties = (payload) => {
  return {
    type: UPDATE_FLOW_PROPERTIES,
    payload: _.pick(payload, ['name', 'flowId', 'botId'])
  }
}

export const saveFlow = (payload) => {
  return {
    type: SAVE_FLOW,
    payload: _.pick(payload, ['flowId', 'botId'])
  }
}

export const deleteFlow = (payload) => {
  return {
    type: DELETE_FLOW,
    payload: _.pick(payload, ['botId', 'flowId'])
  }
}

export const saveFlowSuccess = (payload) => {
  return {
    type: SAVE_FLOW_SUCCESS,
    payload: _.pick(payload, ['flowId'])
  }
}

export const saveandPublishFlow = (payload) => {
  return {
    type: SAVE_AND_PUBLISH_FLOW,
    payload: _.pick(payload, ['flowId', 'botId'])
  }
}

export const saveandPublishFlowSuccess = (payload) => {
  return {
    type: SAVE_AND_PUBLISH_FLOW_SUCCESS,
    payload: _.pick(payload, ['flowId', 'latestPublishedRevision'])
  }
}

export const addAction = (payload) => {
  return {
    type: ADD_ACTION,
    payload
  }
}

export const updateAction = (payload) => {
  return {
    type: UPDATE_ACTION,
    payload
  }
}

export const deleteAction = (payload) => {
  return {
    type: DELETE_ACTION,
    payload: _.pick(payload, ['stepId', 'actionId'])
  }
}

export const updateActionsOrder = (payload) => {
  return {
    type: UPDATE_ACTIONS_ORDER,
    payload: _.pick(payload, ['stepId', 'sourceIndex', 'destinationIndex'])
  }
}

export const updateChoicesOrder = (payload) => {
  return {
    type: UPDATE_CHOICES_ORDER,
    payload: _.pick(payload, ['stepId', 'actionId', 'sourceIndex', 'destinationIndex'])
  }
}

export const setFlowHistory = (payload) => {
  return {
    type: SET_FLOW_HISTORY,
    payload
  }
}

export const updateFlowHistory = (payload) => {
  return {
    type: UPDATE_FLOW_HISTORY,
    payload
  }
}

export const createStep = (payload) => {
  return {
    type: CREATE_STEP,
    payload: _.pick(payload, ['stepId', 'stepName', 'internalName'])
  }
}

export const setActiveFlow = (payload) => {
  return {
    type: SET_ACTIVE_FLOW,
    payload: _.pick(payload, ['flowId', 'botId'])
  }
}

export const unsetActiveFlow = () => {
  return {
    type: UNSET_ACTIVE_FLOW
  }
}

export const fetchFlow = (payload) => {
  return {
    type: FETCH_FLOW,
    payload: _.pick(payload, ['flowId', 'botId'])
  }
}

export const fetchFlowDone = (flow) => {
  return {
    type: FETCH_FLOW_DONE,
    payload: flow
  }
}

export const updateBotResponseSettings = (botResponseSettings) => {
  return {
    type: UPDATE_BOT_RESPONSE_SETTINGS,
    payload: botResponseSettings
  }
}

export const updateStepName = (payload) => {
  return {
    type: UPDATE_STEP_NAME,
    payload: _.pick(payload, ['stepId', 'stepName'])
  }
}

export const deleteStep = (payload) => {
  return {
    type: DELETE_STEP,
    payload: _.pick(payload, ['stepId'])
  }
}

export const showUnsaveMessage = (payload) => {
  return {
    type: SHOW_UNSAVE_MESSAGE,
    payload
  }
}

export const hideUnsaveMessage = (payload) => {
  return {
    type: HIDE_UNSAVE_MESSAGE,
    payload
  }
}
